<template>
  <div class="main_box">
    <h2 class="hidden-md-and-up">充值中心</h2>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search"></div>
        <div class="form_bar_btn"></div>
      </div>
      <div>
        <el-button
          type="primary"
          icon="iconfont chongzhizhongxin"
          @click="recharge()"
        >
          继续充值
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    recharge: function () {
      this.$router.push({ path: '/financial' })
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
